import React, {useEffect, useState} from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { getAllV2Sport } from '../../api/index.js';
import { getUserProvider } from '../../actions/auth.js';
import { Select, Checkbox, CircularProgress, ListItemText, OutlinedInput } from '@mui/material';
import useFetch from '../hooks/useFetch.js';
import SportDTO from '../DTO/SportDTO.js';

export default function SelectDisciplines({ name, selectedDisciplines, handleChange }) {

    const { data, isLoading, error, fetchData} = useFetch(getAllV2Sport, [getUserProvider()]);

    const [sports, setSports] = useState([])

    useEffect(() => {
        fetchData()
    }, [])

    useEffect(() => {
        if(!data)
            return

        // Créer la liste de disciplines
        const sportsDTO = data.map(sport => new SportDTO(sport))

        setSports(sportsDTO.sort((a, b) => a.label.localeCompare(b.label)))
    }, [data])

    if(!sports || sports.length === 0)
        return <CircularProgress />

    const handleSelectChange = (event) => {
        const { value } = event.target;
        const newSelectedDisciplines = value.map(v =>
            sports.flatMap(sport => sport.disciplines).find(d => d._id === v)
        );
        handleChange({target : {value : newSelectedDisciplines, name}});
    };


    return (
        <FormControl fullWidth>
            <InputLabel>Disciplines</InputLabel>
            <Select
                multiple
                name={name}
                label={"Disciplines"}
                value={selectedDisciplines.map(d => d._id)}
                onChange={handleSelectChange}
                input={<OutlinedInput label="Disciplines" />}
                renderValue={(selected) => selected.length > 1 ? 'Plusieurs disciplines' : selectedDisciplines.find(d => d._id === selected[0])?.label}
                MenuProps={{
                getContentAnchorEl: null,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left"
                }
                }}
            >
                {sports.map((sport) => [
                    <MenuItem key={sport._id} value={sport.label} disabled>
                        <ListItemText primary={sport.label} primaryTypographyProps={{ style: { fontWeight: 'bold' } }} />
                    </MenuItem>,
                    ...sport.disciplines.map((discipline) => (
                        <MenuItem key={discipline._id} value={discipline._id}>
                        <Checkbox checked={selectedDisciplines.some(d => d._id === discipline._id)} />
                        <ListItemText primary={discipline.label} />
                        </MenuItem>
                    )),
                ])}
            </Select>
        </FormControl>
    );
}